export function Bars() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M1 4.5A1.5 1.5 0 0 1 2.5 3h18a1.5 1.5 0 1 1 0 3h-18A1.5 1.5 0 0 1 1 4.5ZM1 12c0-.83.672-1.5 1.5-1.5h18c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-18A1.5 1.5 0 0 1 1 12Zm19.5 9h-18a1.5 1.5 0 1 1 0-3h18c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5Z" />
    </svg>
  );
}
